import React from "react";
import ReactQuill from "react-quill";
import { Card, CardBody, CardHeader, Form, FormInput, ListGroup, ListGroupItem } from "shards-react";
import FormCheckbox from "../components-overview/Checkboxes";

import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";

const Editor = () => (
  <Card small className="mb-3">
   <CardHeader className="border-bottom">
      <h6 className="m-0">Do's</h6>
    </CardHeader>
    <CardBody>
      <ListGroup flush>
    <ListGroupItem className="p-1">
        
        Wash your hands regularly for 20 seconds, with soap and water or alcohol-based hand rub <br></br>✋ 🧼 🚰
       
        
      </ListGroupItem>
      <ListGroupItem className="p-1">
        
        Cover your nose and mouth with a disposable tissue or flexed elbow when you cough or sneeze<br></br> 🤧 👃 💪
      
        
      </ListGroupItem>
      <ListGroupItem className="p-1">
        
        Cover your nose and mouth with a disposable tissue or flexed elbow when you cough or sneeze <br></br>🤧 👃 💪
       
        
      </ListGroupItem>
      </ListGroup>
    </CardBody>
  </Card>
);

export default Editor;
